// Five preset avatars — colorful geometric SVGs inspired by the Tangram palette.
// Stored inline as data URIs so no extra network requests are needed and they
// can be persisted directly on the user's `photo` field.
const svg = (bg, shape) => `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><rect width='100' height='100' fill='${bg}'/>${shape}</svg>`
)}`;

export const PRESET_AVATARS = [
  {
    key: "preset:sun",
    label: "Sol",
    url: svg(
      "#F59E0B",
      "<polygon points='50,15 60,45 90,50 60,55 50,85 40,55 10,50 40,45' fill='#FEF3C7'/>",
    ),
  },
  {
    key: "preset:leaf",
    label: "Hoja",
    url: svg(
      "#16A34A",
      "<path d='M20 80 C 20 40, 40 20, 80 20 C 80 60, 60 80, 20 80 Z' fill='#DCFCE7'/><path d='M25 75 L 70 30' stroke='#16A34A' stroke-width='3' fill='none'/>",
    ),
  },
  {
    key: "preset:ocean",
    label: "Océano",
    url: svg(
      "#2563EB",
      "<circle cx='50' cy='50' r='24' fill='#BFDBFE'/><path d='M15 65 Q 30 55 45 65 T 85 65' stroke='#DBEAFE' stroke-width='4' fill='none'/>",
    ),
  },
  {
    key: "preset:tangram",
    label: "Tangram",
    url: svg(
      "#0A2540",
      "<polygon points='15,15 85,15 50,50' fill='#F59E0B'/><polygon points='15,15 15,85 50,50' fill='#2563EB'/><polygon points='85,15 85,85 50,50' fill='#7C3AED'/><polygon points='15,85 85,85 50,50' fill='#16A34A'/>",
    ),
  },
  {
    key: "preset:spark",
    label: "Chispa",
    url: svg(
      "#7C3AED",
      "<polygon points='50,10 58,42 90,50 58,58 50,90 42,58 10,50 42,42' fill='#EDE9FE'/>",
    ),
  },
];

export function findPreset(url) {
  if (!url) return null;
  return PRESET_AVATARS.find((p) => p.url === url) || null;
}
